__turbopack_context__.v({
  "addPill": "IoTT_W_addPill",
  "content": "IoTT_W_content",
});
